import api, { getData } from '@/axiosConfig'
import { status } from '../../helpers'
const gemnoteAPI = api()
import i18n from '../../internatinalization/i18n'

import {
  LOAD_PRODUCTS,
  SET_PRODUCTS,
  LOAD_BUNDLES,
  SET_BUNDLES,
  RESET_PRODUCT_DETAILS,
  LOAD_PRODUCT_DETAILS,
  SET_PRODUCT_DETAILS,
  PRODUCT_NOT_FOUND,
  SET_PRODUCT_VARIANTS,
  SET_VARIANT,
  SET_PRODUCT_VARIANTS_IMAGES,
  SET_VARIANT_DICTIONARY,
  SET_VARIANT_TYPES,
  SET_VARIANT_COLORS,
  UPDATE_VARIANT_COLOR,
  SET_VARIANT_SIZES,
  UPDATE_VARIANT_SIZES,
  SET_DEFAULT_SELECTION,
  LOAD_BUNDLE_DETAILS,
  BUNDLE_NOT_FOUND,
  SET_BUNDLE_DETAILS,
  SET_BUNDLE_ITEMS,
  RESET_PRODUCT_STATE
} from '@/state/mutationTypes'

export default {
  async getVariant({ commit, dispatch }, id) {
    try {
      const response = await gemnoteAPI.get(
        `team/products/${id}/product_variants`
      )

      const productVariants = getData(response)

      if (productVariants.length) {
        commit(SET_VARIANT, productVariants)
      }
    } catch (error) {
      console.log(error)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('product.action.get-products-store-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async getProducts({ commit, dispatch, rootGetters }) {
    try {
      commit(LOAD_PRODUCTS, status.LOADING)
      let isTeamOwner = rootGetters['profile/isTeamOwner']
      const response = await gemnoteAPI.get(`team/products`)
      let products = getData(response)
      products = isTeamOwner
        ? products
        : products.filter(product => product.adminOnly !== true)
      commit(SET_PRODUCTS, products)
      commit(LOAD_PRODUCTS, status.LOADED)
    } catch (error) {
      console.log(error)
      commit(LOAD_PRODUCTS, status.ERROR)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('product.action.get-products-store-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async getProductDetails({ commit, dispatch, state }, id) {
    try {
      commit(RESET_PRODUCT_DETAILS)
      commit(LOAD_PRODUCT_DETAILS, status.LOADING)
      const product = state.productList.find(product => product.id === id)
      if (product) {
        commit(LOAD_PRODUCT_DETAILS, status.LOADED)
        commit(SET_PRODUCT_DETAILS, product)
        commit(PRODUCT_NOT_FOUND, false)
        let response = await gemnoteAPI.get(
          `team/products/${id}/product_variants`
        )
        const productVariants = getData(response)
        commit(SET_PRODUCT_VARIANTS, productVariants)
        commit(SET_PRODUCT_VARIANTS_IMAGES, productVariants)

        let variantDictionary = productVariants.map(variant => {
          return {
            id: variant.id,
            type: variant.attributes.spec.type,
            color: variant.attributes.spec.color,
            hexCode: variant.attributes.hexCode,
            size: variant.attributes.spec.size
          }
        })

        commit(SET_VARIANT_DICTIONARY, variantDictionary)
        commit(SET_VARIANT_TYPES, variantDictionary)
        commit(SET_VARIANT_COLORS, variantDictionary)
        commit(SET_VARIANT_SIZES, variantDictionary)
        commit(SET_DEFAULT_SELECTION)
      } else {
        const response = await gemnoteAPI.get(`team/products`)
        const products = getData(response)
        commit(LOAD_PRODUCTS, status.LOADED)
        commit(SET_PRODUCTS, products)
        const product = state.productList.find(product => product.id === id)
        if (product) {
          commit(LOAD_PRODUCT_DETAILS, status.LOADED)
          commit(SET_PRODUCT_DETAILS, product)
          commit(PRODUCT_NOT_FOUND, false)
          let response = await gemnoteAPI.get(
            `team/products/${id}/product_variants`
          )
          const productVariants = getData(response)
          commit(SET_PRODUCT_VARIANTS, productVariants)
          commit(SET_PRODUCT_VARIANTS_IMAGES, productVariants)

          let variantDictionary = productVariants.map(variant => {
            return {
              id: variant.id,
              type: variant.attributes.spec.type,
              color: variant.attributes.spec.color,
              hexCode: variant.attributes.hexCode,
              size: variant.attributes.spec.size
            }
          })
          commit(SET_VARIANT_DICTIONARY, variantDictionary)
          commit(SET_VARIANT_TYPES, variantDictionary)
          commit(SET_VARIANT_COLORS, variantDictionary)
          commit(SET_VARIANT_SIZES, variantDictionary)
          commit(SET_DEFAULT_SELECTION)
        } else {
          commit(PRODUCT_NOT_FOUND, true)
        }
      }
    } catch (error) {
      console.log(error)
      commit(LOAD_PRODUCT_DETAILS, status.ERROR)
      commit(PRODUCT_NOT_FOUND, false)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('product.action.product-details-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async updateVariantColors({ commit }, variantColorsArray) {
    commit(UPDATE_VARIANT_COLOR, variantColorsArray)
  },
  async updateVariantSizes({ commit }, variantSizesArray) {
    commit(UPDATE_VARIANT_SIZES, variantSizesArray)
  },
  async getProductBundles({ commit, dispatch, rootGetters }) {
    try {
      commit(LOAD_BUNDLES, status.LOADING)
      let isTeamOwner = rootGetters['profile/isTeamOwner']
      const response = await gemnoteAPI.get(`team/bundles`)
      let bundles = getData(response)
      bundles = isTeamOwner
        ? bundles
        : bundles.filter(bundle => bundle.adminOnly !== true)
      commit(SET_BUNDLES, bundles)
      commit(LOAD_BUNDLES, status.LOADED)
    } catch (error) {
      console.log(error)
      commit(LOAD_BUNDLES, status.ERROR)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('product.action.get-bundles-store-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async getBundleDetails({ commit, dispatch, state }, id) {
    try {
      commit(LOAD_BUNDLE_DETAILS, status.LOADING)
      const bundle = state.bundlesList.find(bundle => bundle.id === id)
      if (bundle) {
        commit(LOAD_BUNDLE_DETAILS, status.LOADED)
        commit(SET_BUNDLE_DETAILS, bundle)
        commit(BUNDLE_NOT_FOUND, false)
        let response = await gemnoteAPI.get(`team/bundles/${id}/bundle_items`)
        let bundleItems = getData(response)
        let localBundles = []

        bundleItems.forEach(bundleItem => {
          // This line helps to check if there are multimple variant options to select, if thats the case we'll split up the items
          // const moreThanOneTypeToSelect = bundleItem.attributes.itemable.data
          //   .attributes.product_variants.length
          //   ? Object.values(
          //       bundleItem.attributes.itemable.data.attributes
          //         .product_variants[0].spec
          //     ).filter(spec => spec !== null).length
          //   : 0

          const { qty } = bundleItem.attributes

          const moreThanOneVariantOption = bundleItem.attributes.itemable.data
            .attributes.product_variants.length
            ? bundleItem.attributes.itemable.data.attributes.product_variants
                .length
            : 0

          if (moreThanOneVariantOption > 1 && qty > 1) {
            for (let index = 1; index <= bundleItem.attributes.qty; index++) {
              localBundles.push({
                itemIndex: Math.floor(Math.random() * 1000),
                bundleId: String(bundleItem.id),
                bundleQty: 1, //bundleItem.attributes.qty
                productId: bundleItem.attributes.itemable.data.attributes.id,
                productName:
                  bundleItem.attributes.itemable.data.attributes.name,
                productPrice:
                  bundleItem.attributes.itemable.data.attributes.retail_price,
                productVariants:
                  bundleItem.attributes.itemable.data.attributes
                    .product_variants,
                colorSizeDictionary: [],
                typesToDisplay: [],
                colorsToDisplay: [],
                sizesToDisplay: [],
                selectedVariant: {
                  id: null,
                  name: '',
                  displayName: '',
                  type: null,
                  color: null,
                  size: null,
                  price: null,
                  imageURL: null,
                  inventoriesCount: 0
                }
              })
            }
          } else {
            localBundles.push({
              itemIndex: Math.floor(Math.random() * 1000),
              bundleId: String(bundleItem.id),
              bundleQty: bundleItem.attributes.qty,
              productId: bundleItem.attributes.itemable.data.attributes.id,
              productName: bundleItem.attributes.itemable.data.attributes.name,
              productPrice:
                bundleItem.attributes.itemable.data.attributes.retail_price,
              productVariants:
                bundleItem.attributes.itemable.data.attributes.product_variants,
              colorSizeDictionary: [],
              typesToDisplay: [],
              colorsToDisplay: [],
              sizesToDisplay: [],
              selectedVariant: {
                id: null,
                name: '',
                displayName: '',
                type: null,
                color: null,
                size: null,
                price: null,
                imageURL: null,
                inventoriesCount: 0
              }
            })
          }
        })

        commit(SET_BUNDLE_ITEMS, localBundles)
      } else {
        const response = await gemnoteAPI.get(`team/bundles`)
        const bundles = getData(response)
        commit(LOAD_BUNDLES, status.LOADED)
        commit(SET_BUNDLES, bundles)
        const bundle = state.bundlesList.find(bundle => bundle.id === id)
        if (bundle) {
          commit(LOAD_BUNDLE_DETAILS, status.LOADED)
          commit(SET_BUNDLE_DETAILS, bundle)
          commit(BUNDLE_NOT_FOUND, false)
          let response = await gemnoteAPI.get(`team/bundles/${id}/bundle_items`)
          let bundleItems = getData(response)
          let localBundles = []

          bundleItems.forEach(bundleItem => {
            // This line helps to check if there are multimple variant options to select, if thats the case we'll split up the items
            // const moreThanOneTypeToSelect = bundleItem.attributes.itemable.data
            //   .attributes.product_variants.length
            //   ? Object.values(
            //       bundleItem.attributes.itemable.data.attributes
            //         .product_variants[0].spec
            //     ).filter(spec => spec !== null).length
            //   : 0

            const { qty } = bundleItem.attributes

            const moreThanOneVariantOption = bundleItem.attributes.itemable.data
              .attributes.product_variants.length
              ? bundleItem.attributes.itemable.data.attributes.product_variants
                  .length
              : 0

            if (moreThanOneVariantOption > 1 && qty) {
              for (let index = 1; index <= bundleItem.attributes.qty; index++) {
                localBundles.push({
                  itemIndex: Math.floor(Math.random() * 1000),
                  bundleId: String(bundleItem.id),
                  bundleQty: 1, //bundleItem.attributes.qty
                  productId: bundleItem.attributes.itemable.data.attributes.id,
                  productName:
                    bundleItem.attributes.itemable.data.attributes.name,
                  productPrice:
                    bundleItem.attributes.itemable.data.attributes.retail_price,
                  productVariants:
                    bundleItem.attributes.itemable.data.attributes
                      .product_variants,
                  colorSizeDictionary: [],
                  typesToDisplay: [],
                  colorsToDisplay: [],
                  sizesToDisplay: [],
                  selectedVariant: {
                    id: null,
                    name: '',
                    displayName: '',
                    type: null,
                    color: null,
                    size: null,
                    price: null,
                    imageURL: null,
                    inventoriesCount: 0
                  }
                })
              }
            } else {
              localBundles.push({
                itemIndex: Math.floor(Math.random() * 1000),
                bundleId: String(bundleItem.id),
                bundleQty: bundleItem.attributes.qty,
                productId: bundleItem.attributes.itemable.data.attributes.id,
                productName:
                  bundleItem.attributes.itemable.data.attributes.name,
                productPrice:
                  bundleItem.attributes.itemable.data.attributes.retail_price,
                productVariants:
                  bundleItem.attributes.itemable.data.attributes
                    .product_variants,
                colorSizeDictionary: [],
                typesToDisplay: [],
                colorsToDisplay: [],
                sizesToDisplay: [],
                selectedVariant: {
                  id: null,
                  name: '',
                  displayName: '',
                  type: null,
                  color: null,
                  size: null,
                  price: null,
                  imageURL: null,
                  inventoriesCount: 0
                }
              })
            }
          })

          commit(SET_BUNDLE_ITEMS, localBundles)
        } else {
          commit(BUNDLE_NOT_FOUND, true)
        }
      }
    } catch (error) {
      console.log(error)
      commit(LOAD_BUNDLE_DETAILS, status.ERROR)
      commit(BUNDLE_NOT_FOUND, true)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('product.action.bundle-details-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  resetProductState({ commit }) {
    commit(RESET_PRODUCT_STATE)
  }
}
